import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAddressCompleteGuard } from '@gk/gk-modules';
import { CompositeGuard } from '../../guards/composite/composite.guard';
import { RequestInProgressGuard } from '../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRoutes } from './../../guards/guard.models';
import { MainRequestsListComponent } from './../../shared/main-requests-list/main-requests-list.component';
import { TSFWDRNewRequestComponent } from './new-request/new-request.component';
import { TreesAndShrubsFellingWithDecisionRequestComponent } from './trees-and-shrubs-felling-with-decision-request.component';

const treesAndShrubsFellingWithDecisionRequestRoutes: Routes = [
  {
    path: MainRoutes.TreesAndShrubsFellingWithDecisionRequest,
    component: TreesAndShrubsFellingWithDecisionRequestComponent,
    canActivate: [CompositeGuard],
    data: {
      guards: [SessionGuard, IsAddressCompleteGuard],
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: TSFWDRNewRequestComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(treesAndShrubsFellingWithDecisionRequestRoutes),
  ],
  providers: [CompositeGuard, SessionGuard, IsAddressCompleteGuard],
  exports: [RouterModule],
})
export class TreesAndShrubsFellingWithDecisionRequestRoutingModule {}
